// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"3c53a7b9cf3d242c9544","418":"dacbec9ef378919690a3"}[chunkId] + ".js";
};